///<reference path="../short-cuts/index.d.ts"/>

module Meevo.Components.BaseClasses {
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export interface ISettingsPageController<M> {
        model: M;
        readonly editSecurityKey: string;
        readonly entityEndpoint: string;
        readonly title: string;
        readonly isEditing: boolean;
        readonly isReadonly: boolean;
        readonly mode: MaintenanceFormState;
        readonly isApplicationModeCO: boolean;
        closeContext(): void;
        save(): angular.IPromise<M>;
        edit(): void;
        cancel(): void;
    }

    export abstract class SettingsPageController<M> extends ShortCutsStateManagerController implements ISettingsPageController<M> {
        private _mode: MaintenanceFormState;

        protected shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };
        // protected abstract noun: Meevo.Model.NounEnum;

        protected backUp: M;
        model: M;

        protected abstract get baseSecurityKey(): string;

        get editSecurityKey() {
            return this.baseSecurityKey + SecurityParts.KEY_PART_WRITE;
        }

        abstract get entityEndpoint(): string;

        abstract get title(): string;

        get isEditing(): boolean {
            return this.mode === MaintenanceFormState.Editing;
        }

        get isReadonly(): boolean {
            return this.mode === MaintenanceFormState.Readonly;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return this._mode;
        }

        get isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        constructor(
            protected $scope: ng.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IStateService,
            protected shortCutsService: IShortCutsService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
        ) {
            super($scope, $state, shortCutsService);

            this._mode = MaintenanceFormState.Readonly;
            this.setShortcuts();
            this.preloadData();
        }

        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        save(): angular.IPromise<M> {
            this.busyService.start();

            this._mode = MaintenanceFormState.Readonly;

            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.entityEndpoint}`, 'POST', this.model)
                .then((res) => {
                    this.model = res.data;

                    return this.model;
                })
                .finally(() => this.busyService.stop());
        }

        edit(): void {
            this.setBackUp();
            this._mode = MaintenanceFormState.Editing;
        }

        cancel(): void {
            this.rollbackChanges();
            this._mode = MaintenanceFormState.Readonly;
        }

        protected preloadData(): angular.IPromise<M> {
            this.busyService.start();

            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.entityEndpoint}`, 'GET', null)
                .then((res) => {
                    this.model = res.data;

                    return this.model;
                })
                .finally(() => this.busyService.stop());
        }

        protected setShortcuts(): void {
            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.edit();
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.save();
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.cancel();
                    }
                }])
            };
        }

        protected setBackUp(): void {
            this.backUp = angular.copy(this.model);
        }

        protected rollbackChanges(): void {
            this.model = angular.copy(this.backUp);
        }
    }
}
